module.exports = __webpack_public_path__ + "static/media/axletree.f706715c.png";